import type { SupabaseClient } from "@supabase/supabase-js"

export type WorkspaceAccessRole = "owner" | "member" | "none"

export async function getWorkspaceAccess(
  client: SupabaseClient,
  userId: string,
  workspaceId: string
): Promise<WorkspaceAccessRole> {
  const { data: ws, error: wsErr } = await client
    .from("workspaces")
    .select("user_id")
    .eq("id", workspaceId)
    .maybeSingle()

  if (wsErr || !ws) return "none"
  if ((ws as { user_id: string }).user_id === userId) return "owner"

  const { data: mem, error: mErr } = await client
    .from("workspace_members")
    .select("id")
    .eq("workspace_id", workspaceId)
    .eq("user_id", userId)
    .maybeSingle()

  if (mErr || !mem) return "none"
  return "member"
}

export async function fetchWorkspaceTitleDestination(
  client: SupabaseClient,
  userId: string,
  workspaceId: string
): Promise<{ name: string; destination: string } | null> {
  if ((await getWorkspaceAccess(client, userId, workspaceId)) === "none") return null
  const { data, error } = await client
    .from("workspaces")
    .select("name, destination")
    .eq("id", workspaceId)
    .maybeSingle()
  if (error || !data) return null
  return {
    name: data.name as string,
    destination: data.destination as string,
  }
}
